module.exports = ":host * {\n  animation: fadein 1s; }\n\n.img-fluid-wrapper {\n  display: block;\n  width: 100%; }\n\nh2 {\n  font-size: 1.5rem; }\n\nngb-carousel {\n  margin-bottom: 2rem; }\n  ngb-carousel:focus {\n    outline: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/art/project.component.scss
// module id = 199
// module chunks = 1